export enum InputType {
  PASSWORD = 'password',
  TEXT = 'text',
  EMAIL = 'email',
  CHECKBOX = 'checkbox',
  DATE = 'date',
  TICKET_COMMENT = 'comment',
  NUMBER = 'number',
}
